const STORAGE_KEY = 'picnic:basket-session';
export function loadStoredSession() {
    if (typeof window === 'undefined')
        return null;
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (!parsed.accessToken || !parsed.refreshToken)
            return null;
        return {
            accessToken: String(parsed.accessToken),
            refreshToken: String(parsed.refreshToken),
            accessExpiresAt: Number(parsed.accessExpiresAt || 0),
            refreshExpiresAt: Number(parsed.refreshExpiresAt || 0),
        };
    }
    catch {
        return null;
    }
}
export function persistSession(session) {
    if (typeof window === 'undefined')
        return;
    if (!session) {
        window.localStorage.removeItem(STORAGE_KEY);
        return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}
